import { SeasonStepKey } from "@api/generated/model";
import type { RoutePath } from "./nav";

/** The screen of each step of the home page's season cycle. The steps and their order are the server's
 *  (`system.application.model.StepKey`): a new step does not compile here until it has its screen. */
const SCREENS: Record<SeasonStepKey, RoutePath> = {
  selection: "/season/selection",
  crossing: "/season/crossing",
  genebank: "/genebank/genebank",
  seed_exchange: "/genebank/shipments",
  plot_numbering: "/season/plot-numbering",
  field_books: "/season/field-books",
  labels: "/analysis/labels",
};

export const SEASON_CYCLE = Object.values(SeasonStepKey).map((key) => ({ key, to: SCREENS[key] }));

export const stepRoute = (key: SeasonStepKey): RoutePath => SCREENS[key];
/** The step a screen does (none for a screen outside the cycle). */
export const stepOf = (pathname: string): SeasonStepKey | undefined => SEASON_CYCLE.find((s) => s.to === pathname)?.key;
/** The step after ``key`` (none after the last). */
export const nextStep = (key: SeasonStepKey) => SEASON_CYCLE[SEASON_CYCLE.findIndex((s) => s.key === key) + 1];
export const stepNumber = (key: SeasonStepKey) => SEASON_CYCLE.findIndex((s) => s.key === key) + 1;
